import { useEffect } from 'react'

/**
 * Hook to automatically focus an element on mount or when enabled
 * Encapsulates the common modal pattern of focusing a message/title on open
 *
 * @param {React.RefObject} ref - Ref to the element to focus
 * @param {boolean} enabled - Whether to focus (default: true)
 */
export function useAutoFocus (ref, enabled = true) {
  useEffect(() => {
    if (enabled && ref.current) {
      ref.current.focus()
    }
  }, [enabled])
}
